export default "__VITE_ASSET__ca907ab2__"